import { Component, OnInit } from '@angular/core';
import { CarrinhoItemsModel } from '../../../../models/carrinhoItems.model';
//import { CarrinhoModel } from '../../../../models/carrinho.model';
import { UsersService } from '../../../../models/usuarios.service';
import { AngularFirestore } from '../../../../node_modules/angularfire2/firestore';
import { DataModel } from '../../../../models/data.model';
//import { MomentModule } from 'angular2-moment';


@Component({
  selector: 'pedidos-nao-atendidos',
  templateUrl: './pedidos-nao-atendidos.component.html',
  styleUrls: ['./pedidos-nao-atendidos.component.scss']
})


export class PedidosNaoAtendidosComponent implements OnInit {
  fornecedor: number = 0;
  estado: number = 0;
  pedidos: CarrinhoItemsModel;
  items: any[] = [];
  full = true;

  constructor (
    private db: AngularFirestore,
    private usersService: UsersService) {

    this.fornecedor = usersService.fornecedor;

  }

  ngOnInit() {
    this.pedidos = new CarrinhoItemsModel(this.db, this.usersService);
    if (this.fornecedor || 0 == 0) { // usado no menu, avaliar se pode abrir para outros fornecedores    
      this.pedidos.carregarPedidosNovos(d => {
        console.log('chegou', d);
        this.items = d;
      }, this.fornecedor || 0, this.estado);
    } else {
      this.pedidos.carregarPedidosNovos(d => {
        console.log('chegou', d);
        this.items = d;
      }, this.fornecedor, this.estado);

    }
    console.log('novos pedidos');
  }


  getDataStr(dt) {
    let d: Date = DataModel.toDate(dt);

    return DataModel.toDateAge(dt);
  }

}
